const dateISORegex = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*))(?:Z|(\+|-)([\d|:]*))?$/;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isIsoDateString = (value) => value && typeof value === 'string' && dateISORegex.test(value);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const handleDates = (body) => {
    if (body === null || body === undefined || typeof body !== 'object') {
        return;
    }
    for (const key of Object.keys(body)) {
        const value = body[key];
        if (isIsoDateString(value)) {
            // eslint-disable-next-line no-param-reassign
            body[key] = new Date(value);
        }
        else if (typeof value === 'object') {
            handleDates(value);
        }
    }
};
const parseJsonString = (jsonString, logger = undefined) => {
    try {
        const parsedEvent = JSON.parse(jsonString);
        if (!parsedEvent) {
            logger?.error("Can't parse event data as a valid json", jsonString);
            return undefined;
        }
        handleDates(parsedEvent);
        return parsedEvent;
    }
    catch (ex) {
        logger?.error('Unhandled exception on parsing json', ex, jsonString);
        return undefined;
    }
};

const isNullOrEmpty = (str) => {
    if (!str) {
        return true;
    }
    if (str.trim().length === 0) {
        return true;
    }
    return false;
};
const isNotPopulatedId = (nmb) => {
    if (!nmb) {
        return true;
    }
    if (nmb <= 0) {
        return true;
    }
    return false;
};
const isCountryCode = (str) => {
    if (!str) {
        return false;
    }
    if (str.length !== 2) {
        return false;
    }
    return true;
};
const isEnumValue = (str, enumVariable) => {
    const enumValues = Object.values(enumVariable);
    return enumValues.includes(str);
};

const tryParseAsEnum = (type, input) => {
    if (isNullOrEmpty(input)) {
        return undefined;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const casted = input;
    return type[casted];
};
const tryParseAsConstEnum = (enumObj, value) => {
    return Object.values(enumObj).includes(value) ? value : undefined;
};
const tryParseAsEnumArray = (type, inputs) => {
    if (!inputs) {
        return undefined;
    }
    if (!Array.isArray(inputs)) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const x = tryParseAsEnum(type, inputs.toString());
        if (x)
            return [x];
        return undefined;
    }
    const result = inputs?.map((input) => {
        const enumVal = tryParseAsEnum(type, input);
        return enumVal !== undefined ? enumVal : type[''];
    });
    return result;
};
const tryParseAsNumber = (input, signedNumber = false) => {
    if (!input && input !== 0) {
        return undefined;
    }
    const numberVal = Number(input);
    if (Number.isNaN(numberVal)) {
        return undefined;
    }
    if (!signedNumber && numberVal < 0) {
        return 0;
    }
    return numberVal;
};
const tryParseAsBoolean = (input) => {
    if (input === true)
        return true;
    if (input === false)
        return false;
    if (!input)
        return undefined;
    if (input === 'true')
        return true;
    if (input === 'false')
        return false;
    return undefined;
};
const tryParseDecimal = (value) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return value !== 0 && !value ? null : parseFloat(value.toString());
};
const tryParseAsDate = (input) => {
    if (!input) {
        return undefined;
    }
    const parseResult = Date.parse(input);
    if (Number.isNaN(parseResult)) {
        return undefined;
    }
    return new Date(parseResult);
};
const tryParseAsNumberArray = (inputs) => {
    if (!inputs) {
        return undefined;
    }
    if (!Array.isArray(inputs)) {
        const x = tryParseAsNumber(inputs);
        if (x)
            return [x];
        return undefined;
    }
    const result = inputs?.map((input) => {
        const number = tryParseAsNumber(input);
        return number !== undefined ? number : 0;
    });
    return result;
};
const getEnumFirstValue = (enumVariable) => {
    const enumValues = Object.values(enumVariable);
    return enumValues[0];
};

const parseFileUrl = (url) => {
    const parts = url.split('/');
    const domain = parts[2];
    const domainParts = domain.split('.');
    const bucket = domainParts[0];
    const key = `${parts.slice(3).join('/')}`;
    const filename = parts[parts.length - 1];
    return { bucket, key, filename };
};

export { getEnumFirstValue, handleDates, isCountryCode, isEnumValue, isNotPopulatedId, isNullOrEmpty, parseFileUrl, parseJsonString, tryParseAsBoolean, tryParseAsConstEnum, tryParseAsDate, tryParseAsEnum, tryParseAsEnumArray, tryParseAsNumber, tryParseAsNumberArray, tryParseDecimal };
//# sourceMappingURL=index.js.map
